import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

function List() {

    const pathFrontEnd = '/fiscalcategories/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}fiscalcategories/delete`,
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpoint: config.endpoints.backend + 'fiscalcategories/getall'
    }
    
    const profileFilter = chooseProfileFilter();

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            } : {},
            {
                name: 'description',
                type: 'text',
                label: 'Descrição',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Categorias Tributárias',
        labelTitleButtonAdd: 'Incluir nova categoria',
        fieldsShowOnDelete: ['entity_name','description'],
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        showPrintButtons: true,
        columns: [
            {
                name: 'entity_name',
                label: 'Entidade'
            },
            {
                name: 'description',
                label: 'Descrição'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
